import { render } from "./CompanyPartners.vue?vue&type=template&id=87ed7db2&scoped=true&ts=true"
import script from "./CompanyPartners.vue?vue&type=script&lang=ts"
export * from "./CompanyPartners.vue?vue&type=script&lang=ts"

import "./CompanyPartners.vue?vue&type=style&index=0&id=87ed7db2&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87ed7db2"]])

export default __exports__